import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Wrapper from '../../components/wrapper';
import GlobalNavigationLink from './link';
import NavigationContainer from '../../components/navigation-container';
import './styles.css';
import {convertPipeToBrTag} from "../../utils";
import BodyControl from "../../components/body";
import CarNavigation from "../car-navigation";

//import {HAS_TOUCH} from '../../constants/environment';

/**
 * GlobalNavigation
 */
class GlobalNavigation extends Component {
  static propTypes = {
    containerId: PropTypes.string,
    containerClass: PropTypes.string,
    children: PropTypes.arrayOf(PropTypes.node),
  };
  static defaultProps = {
    containerId: null,
    containerClass: null,
    children: null,
  };

  constructor(props) {
    super();
    this.props = props;
    this.state = {};
    this.items = [];
    this.dropDownLinkIndexArr = [];
    this.isTablet = false;
    this.intervalId = null;
    //
    // const ua = window.navigator.userAgent.toLowerCase();
    // //const ua = navigator.userAgent;
    // if (ua.indexOf('iphone') > 0 || ua.indexOf('android') > 0 && ua.indexOf('mobile') > 0) {
    //     // スマートフォン用コード
    // } else if (ua.indexOf('ipad') > 0 || ua.indexOf('android') > 0) {
    //     // タブレット用コード
    //     this.isTablet = true;
    // } else {
    //     // PC用コード
    // }
  }

  render() {
    this.items = [];
    this.dropDownLinkIndexArr = [];
    //
    return (
      <Wrapper
        containerId={this.props.containerId}
        containerClass={this.props.containerClass}
      >
        <nav className={'GlobalNavigation' + ((this.isTablet === true) ? ' tablet': '')}>
          <h3 className="GlobalNavigation__heading">{'Global navigation'}</h3>
          {(() => {
            if (this.props.children !== null) {
              return (
                <NavigationContainer
                  getItemPositions={this.getItemPositions}
                  getCurrentItemPosition={this.getCurrentItemPosition}
                  excludedWidth={148}
                  opacity={1}
                >
                  <ul className="GlobalNavigation__list-ul">
                    <li><a class="GlobalNavigation__link" href="https://www2.mazda.co.jp/brand/"><span class="GlobalNavigation__link-container"><div>ブランド</div></span><span class="GlobalNavigation__link-border"></span></a></li>
                    {this.props.children.map((child, index) => {
                      // if (child.type.displayName === 'withDynamicComponents(PromoNavigation)') {
                      if (0 <= child.type.displayName.indexOf('withDynamicComponents(PromoNavigation)')) {
                        this.items.push('item' + index);
                        this.dropDownLinkIndexArr.push(index);
                        // PromoNavigation
                        return (
                          <li key={index} ref={'item' + index}>
                            <DropDownList ref={index}>
                              <DropDownLink
                                href={(child.props.link && child.props.link.href !== null) ? child.props.link.href: null}
                                external={(child.props.link && child.props.link.targetBlank !== null) ? child.props.link.targetBlank: null}
                                pageName={(child.props.link && child.props.link.pageName !== null) ? child.props.link.pageName: null}
                                pcText={(child.props.link && child.props.link.pcText !== null) ? child.props.link.pcText: null}
                                mbText={(child.props.link && child.props.link.mbText !== null) ? child.props.link.mbText: null}
                                current={(child.props.link && child.props.link.current !== null) ? child.props.link.current: null}
                                index={index}
                                onClick={(index) => {
                                  this.handleClick(index)
                                }}
                              />
                              {child}
                            </DropDownList>
                          </li>
                        )
                      } else if (child.type.displayName === 'GlobalNavigationLink') {
                        this.items.push('item' + index);
                        // GlobalNavigationLink
                        return (
                          <li key={index} ref={'item' + index} data-current={(child.props.current) ? 'current': ''}>
                            <GlobalNavigationLink
                              href={child.props.href}
                              external={child.props.external}
                              pageName={child.props.pageName}
                              pcText={child.props.pcText}
                              mbText={child.props.mbText}
                              current={child.props.current}
                            />
                          </li>
                        )
                      // } else if (child.type.displayName === 'withDynamicComponents(CarNavigation)') {
                      } else if (0 <= child.type.displayName.indexOf('withDynamicComponents(CarNavigation)')) {
                        this.items.push('item' + index);
                        this.dropDownLinkIndexArr.push(index);
                        // CarNavigation
                        return (
                          <li key={index} ref={'item' + index}>
                            <DropDownList ref={index}>
                              <DropDownLink
                                href={(child.props.link && child.props.link.href !== null) ? child.props.link.href: null}
                                external={(child.props.link && child.props.link.targetBlank !== null) ? child.props.link.targetBlank: null}
                                pageName={(child.props.link && child.props.link.pageName !== null) ? child.props.link.pageName: null}
                                pcText={(child.props.link && child.props.link.pcText !== null) ? child.props.link.pcText: null}
                                mbText={(child.props.link && child.props.link.mbText !== null) ? child.props.link.mbText: null}
                                current={(child.props.link && child.props.link.current !== null) ? child.props.link.current: null}
                                index={index}
                                onClick={(index) => {
                                  this.handleClick(index)
                                }}
                              />
                              <CarNavigation
                                {...child.props}
                                parentIndex={index}
                                onChange={(index) => {
                                  this.handleResize(index)
                                }}
                              />
                            </DropDownList>
                          </li>
                        )
                      } else {
                        return null;
                      }
                    })}
                  </ul>
                </NavigationContainer>
              )
            } else {
              return null
            }
          })()}
        </nav>
      </Wrapper>
    )
  }

  //
  getItemPositions = () => {
    let arr = [0];
    let total = 0;
    let i, max;
    for (i = 0, max = this.items.length; i < max; i = i + 1) {
      const width = this.refs[this.items[i]].clientWidth;
      total = total + width;
      arr.push(total);
    }
    return arr;
  };

  //
  getCurrentItemPosition = () => {
    let total = 0;
    let i, max;
    for (i = 0, max = this.items.length; i < max; i = i + 1) {
      const width = this.refs[this.items[i]].clientWidth;
      if (this.refs[this.items[i]].dataset.current === 'current') {
        return total + (width / 2)
      }
      total = total + width;
    }
    return 0;
  };

  //
  handleClick = (index) => {
    if (this.intervalId) clearTimeout(this.intervalId);
    this.dropDownLinkIndexArr.map((i) => {
      if (i === index) {
        this.intervalId = setTimeout(() => {
          this.refs[i].toggle();
        }, 100);
      } else {
        this.refs[i].close();
      }
    })
  };

  //
  handleResize = (index) => {
    this.dropDownLinkIndexArr.map((i) => {
      if (i === index) {
        setTimeout(() => {
          this.refs[i].handleResize();
        }, 100);
      }
    })
  };

}

export default GlobalNavigation;

// プロモナビゲーションとカーナビゲーション用のドロップダウン
class DropDownList extends Component {
  static propTypes = {
    open: PropTypes.bool,
    children: PropTypes.node,
  };
  static defaultProps = {
    open: false,
    children: null,
  };

  constructor(props) {
    super();
    this.props = props;
    this.state = {
      append: false,
      open: this.props.open,
      height: 0,
    };
    this.intervalId = null;
    this.intervalId2 = null;
    this.intervalId3 = null;
  }

  componentDidMount() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  };

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  render() {
    if (this.state.append === true) {
      return (
        <dl className={'GlobalNavigation__list-dl' + ((this.state.open === true) ? ' open': '')}>
          <dt>
            {this.props.children[0]}
          </dt>
          <dd style={{height: this.state.height}}>
            <div className="GlobalNavigation__box" ref="content">{this.props.children[1]}</div>
          </dd>
          <a className="GlobalNavigation__link-close" href="#" onClick={(e) => {
            e.preventDefault();
            this.close()
          }}>Close</a>
        </dl>
      )
    } else {
      return (
        <dl className={'GlobalNavigation__list-dl' + ((this.state.open === true) ? ' open': '')}>
          <dt>
            {this.props.children[0]}
          </dt>
          <dd style={{height: this.state.height}}>
            <div className="GlobalNavigation__box" ref="content"/>
          </dd>
          <a className="GlobalNavigation__link-close" href="#" onClick={(e) => {
            e.preventDefault();
            this.close()
          }}>Close</a>
        </dl>
      )
    }
  }
  // render() {
  //   return (
  //     <dl className={'GlobalNavigation__list-dl' + ((this.state.open === true) ? ' open': '')}>
  //       <dt>
  //         {this.props.children[0]}
  //       </dt>
  //       <dd style={{height: this.state.height}}>
  //         <div className="GlobalNavigation__box" ref="content">{this.props.children[1]}</div>
  //       </dd>
  //       <a className="GlobalNavigation__link-close" href="#" onClick={(e) => {
  //         e.preventDefault();
  //         this.close()
  //       }}>Close</a>
  //     </dl>
  //   )
  // }

  //
  toggle = () => {
    if (this.state.open === true) {
      this.close();
    } else {
      this.open();
    }
  };

  //
  open = () => {
    if (this.state.open === true) return;
    this.setState({
      append: true,
    });
    // BODYのスクロール無効化
    BodyControl.setUnScrollPc();
    if (this.intervalId) clearTimeout(this.intervalId);
    if (this.intervalId2) clearTimeout(this.intervalId2);
    if (this.intervalId3) clearTimeout(this.intervalId3);
    this.intervalId = setTimeout(()=> {
      this.setState({
        open: true,
        height: this.getHeight(),
      });
    }, 100);
    this.intervalId3 = setInterval(()=> {
      this.setState({
        height: this.getHeight(),
      });
    }, 500);
  };
  // open = () => {
  //   if (this.state.open === true) return;
  //   this.setState({
  //     open: true,
  //     height: this.getHeight(),
  //   });
  //   // BODYのスクロール無効化
  //   BodyControl.setUnScrollPc();
  // };

  //
  close = () => {
    if (this.state.open === false) return;
    this.setState({
      height: 0,
      open: false,
    });
    // BODYのスクロール無効化を解除
    BodyControl.clearUnScroll();
    if (this.intervalId) clearTimeout(this.intervalId);
    if (this.intervalId2) clearTimeout(this.intervalId2);
    if (this.intervalId3) clearTimeout(this.intervalId3);
    this.intervalId2 = setTimeout(()=> {
      this.setState({
        append: false,
      });
    }, 1000);
  };
  // close = () => {
  //   if (this.state.open === false) return;
  //   this.setState({
  //     open: false,
  //     height: 0,
  //   });
  //   // BODYのスクロール無効化を解除
  //   BodyControl.clearUnScroll();
  // };

  //
  handleResize = () => {
    if (this.state.open === false) return;
    this.setState({height: this.getHeight()});
  };

  //
  getHeight = () => {
    if (768 <= window.innerWidth) {
      return window.innerHeight - 50;
    } else {
      return this.refs.content.clientHeight;
    }
  }

}

// リンク
const DropDownLink = ({
                        href,
                        external,
                        pageName,
                        pcText,
                        mbText,
                        index,
                        onClick,
                        current,
                      }) => {
  const handleClick = (e) => {
    if (onClick !== null && typeof onClick === 'function') {
      e.preventDefault();
      onClick(index);
    }
  };
  //
  const getPcText = () => {
    if (pcText !== null) {
      return pcText;
    } else if (pageName !== null) {
      return pageName;
    } else {
      return '';
    }
  };
  const getMbText = () => {
    if (mbText !== null) {
      return mbText;
    } else if (pcText !== null) {
      return pcText;
    } else if (pageName !== null) {
      return pageName;
    } else {
      return '';
    }
  };
  //
  if (!href) {
    return (
      <a className="GlobalNavigation__link"
         href={(href !== null) ? href: ''}
         target={(external === true) ? '_blank': ''}
         onClick={(e) => {
           handleClick(e)
         }}
      >
        <span className="GlobalNavigation__link-container">
          <span className="GlobalNavigation__link-pc">
            <div dangerouslySetInnerHTML={{__html: convertPipeToBrTag(getPcText())}}/>
          </span>
          <span className="GlobalNavigation__link-mb">
            <div dangerouslySetInnerHTML={{__html: convertPipeToBrTag(getMbText())}}/>
          </span>
          <span className="GlobalNavigation__link-icon"/>
          <span className="GlobalNavigation__link-icon2"/>
        </span>
        <span className="GlobalNavigation__link-border"/>
      </a>
    )
  } else {
    return (
      <a className={'GlobalNavigation__link' + ((current === true) ? ' current': '')}
         href="#"
         onClick={(e) => {
           handleClick(e)
         }}
      >
        <span className="GlobalNavigation__link-container">
          <span className="GlobalNavigation__link-pc">
            <div dangerouslySetInnerHTML={{__html: convertPipeToBrTag(getPcText())}}/>
          </span>
          <span className="GlobalNavigation__link-mb">
            <div dangerouslySetInnerHTML={{__html: convertPipeToBrTag(getMbText())}}/>
          </span>
          <span className="GlobalNavigation__link-icon"/>
          <span className="GlobalNavigation__link-icon2"/>
        </span>
        <span className="GlobalNavigation__link-border"/>
      </a>
    )
  }

};



// WEBPACK FOOTER //
// ./src/containers/global-navigation/index.jsx